export default "__VITE_ASSET__2632ac57__"